module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "color": "var(--regpwd-primarytextcolor)"
    }
  }, [_c('spinner', {
    attrs: {
      "spinnerOn": _vm.loading
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "splash hiddden",
    attrs: {
      "src": "",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal errorModal",
    staticStyle: {
      "z-index": "9999"
    },
    attrs: {
      "role": "dialog",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "color": "#00524a"
    }
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticStyle: {
      "margin-right": "233px",
      "width": "100%",
      "text-align": "left"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.errorMsg) + "\n            ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary btn-block btn-lg col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "margin-top": "15px"
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.errorModalClick($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.user_lang.activationOk))])])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none",
      "box-shadow": "2px 2px 10px #ccc"
    },
    attrs: {
      "id": "userRegistration"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tokenInvalid && !_vm.enableRefIdApproach),
      expression: "tokenInvalid && !enableRefIdApproach"
    }],
    staticStyle: {
      "max-width": "800px",
      "margin": "auto",
      "padding-top": "35px",
      "padding": "35px",
      "background": "#fff"
    }
  }, [_vm._m(0), _vm._v(" "), (_vm.isNetworkError) ? _c('div', {
    staticStyle: {
      "padding": "15px 0px"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.user_lang.msgForGenericErrorUA) + "\n        ")]) : _vm._e(), _vm._v(" "), (!_vm.isNetworkError) ? _c('div', [(!_vm.inviteSuccess) ? _c('div', {
    staticStyle: {
      "padding": "10px"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.user_lang.tokenInvalidShortMessage) + "\n          ")]) : _vm._e(), _vm._v(" "), (!_vm.inviteSuccess && _vm.detectBrowser()) ? _c('div', {
    staticStyle: {
      "padding": "10px"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.user_lang.browserspecificmsg) + "\n          ")]) : _vm._e(), _vm._v(" "), (!_vm.inviteSuccess) ? _c('div', {
    staticStyle: {
      "padding": "10px"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.user_lang.enterActivationDetails) + "\n          ")]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticStyle: {
      "text-align": "center",
      "padding": "10px"
    }
  }, [_c('h5', [_vm._v(_vm._s(_vm.user_lang.resendActivation))])]), _vm._v(" "), (!_vm.inviteSuccess) ? _c('div', [_c('div', {
    staticStyle: {
      "padding": "10px"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 field-reinvite"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userEmail),
      expression: "userEmail"
    }],
    staticClass: "input-reinvite",
    attrs: {
      "type": "text",
      "placeholder": _vm.user_lang.username
    },
    domProps: {
      "value": (_vm.userEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.userEmail = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-12 field-reinvite"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userLastName),
      expression: "userLastName"
    }],
    staticClass: "input-reinvite",
    attrs: {
      "type": "text",
      "placeholder": _vm.user_lang.last_name
    },
    domProps: {
      "value": (_vm.userLastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.userLastName = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "10px",
      "width": "100%",
      "text-align": "center",
      "margin": "0px auto"
    },
    attrs: {
      "id": "captcha_container"
    }
  }, [_c('vue-recaptcha', {
    attrs: {
      "sitekey": _vm.sitekey,
      "loadRecaptchaScript": true
    },
    on: {
      "verify": _vm.onVerify,
      "expired": _vm.onExpired,
      "render": _vm.onRender
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-left": "10px"
    }
  }, [(_vm.userValidations !== '') ? _c('div', {
    staticClass: "validation-text"
  }, [_vm._v("\n                  " + _vm._s(_vm.userValidations) + "\n                ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "10px"
    }
  }, [_c('button', {
    class: {
      disabled: !_vm.captchaVerified
    },
    staticStyle: {
      "width": "100%"
    },
    on: {
      "click": function($event) {
        _vm.validateAndResendInvite()
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.user_lang.reinvite) + "\n                ")])])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.inviteSuccess) ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "padding": "10px",
      "border-top": "1px solid #ccc",
      "padding-top": "20px"
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.user_lang.reinviteEmailMessage))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-top": "20px"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.user_lang.reinviteContactAdminMessage) + "\n          ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.enableRefIdApproach && !_vm.tokenInvalid),
      expression: "enableRefIdApproach && !tokenInvalid"
    }],
    staticStyle: {
      "max-width": "800px",
      "margin": "auto",
      "padding-top": "35px",
      "padding": "50px",
      "background": "#fff"
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "10px"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.copyrefid) + "\n        ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "10px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.refId),
      expression: "refId"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.refId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.refId = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "10px"
    }
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.getTokenAndRedirect(_vm.refId)
      }
    }
  }, [_vm._v("Register")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.tokenInvalid && !_vm.enableRefIdApproach),
      expression: "!tokenInvalid && !enableRefIdApproach"
    }],
    staticClass: "okta-sign-in-header auth-header"
  }, [_c('img', {
    staticClass: "auth-org-logo",
    attrs: {
      "src": "static/1200px-Cargill_logo.svg.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.tokenInvalid && !_vm.enableRefIdApproach),
      expression: "!tokenInvalid && !enableRefIdApproach"
    }],
    staticClass: "container-fluid",
    staticStyle: {
      "background": "#fff"
    }
  }, [_c('div', {
    staticClass: "title-bar"
  }, [_c('p', {
    staticClass: "welcome"
  }, [_c('span', {
    staticStyle: {
      "color": "var(--regpwd-secondarytextcolor)",
      "font-size": "15px",
      "font-weight": "bold"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.user_lang.welcome_cargill) + "\n              "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.browserLang != 'uk'),
      expression: "browserLang != 'uk'"
    }]
  }, [_vm._v(_vm._s(_vm.brand))])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.accountsetup),
      expression: "!accountsetup"
    }],
    staticClass: "row",
    attrs: {
      "id": "registrationForm"
    }
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "background": "#fff"
    }
  }, [_c('div', {
    staticStyle: {
      "max-width": "800px",
      "margin": "auto"
    }
  }, [_c('div', {
    staticClass: "setup-section col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "padding-top": "0px"
    }
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "margin": "auto",
      "text-align": "left",
      "margin-top": "5px"
    }
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.password_placeholder))]), _vm._v(" "), _c('div', {
    staticClass: "row-spacing"
  }, [_c('div', {
    staticClass: "field-spacing"
  }, [_c('span', [_vm._v(_vm._s(_vm.user_lang.enter_new_pwd))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    class: _vm.borderForInputOne,
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    class: _vm.inputOneHasError
  })]), _vm._v(" "), (_vm.showPasswordError) ? _c('div', {
    staticClass: "errorwrapper"
  }, _vm._l((_vm.pwdValidationObj), function(i) {
    return _c('span', {
      key: i,
      staticClass: "pwderror"
    }, [_vm._v(_vm._s(i))])
  })) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "field-spacing"
  }, [_c('span', [_vm._v(_vm._s(_vm.user_lang.repeat_pwd))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.repeatpassword),
      expression: "repeatpassword"
    }],
    class: _vm.borderForInputTwo,
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "password"
    },
    domProps: {
      "value": (_vm.repeatpassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.repeatpassword = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    class: _vm.inputTwoHasError
  })]), _vm._v(" "), (_vm.showPasswordError) ? _c('div', {
    staticClass: "errorwrapper"
  }, _vm._l((_vm.repeatPwdValidationObj), function(i) {
    return _c('span', {
      key: i,
      staticClass: "pwderror"
    }, [_vm._v(_vm._s(i))])
  })) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((_vm.availableFactorID === '' || _vm.availableFactorID === undefined) && !_vm.isGroupPhone),
      expression: "(availableFactorID === '' || availableFactorID === undefined) && !isGroupPhone"
    }],
    staticClass: "setup-section col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "display": "none"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "margin": "auto",
      "text-align": "left",
      "margin-top": "5px"
    }
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.nop) + " " + _vm._s(_vm.user_lang.optional))]), _vm._v(" "), _c('span', {
    staticClass: "fa fa-info-circle",
    staticStyle: {
      "padding-left": "5px"
    },
    attrs: {
      "title": _vm.user_lang.phone_inst,
      "data-original-title": _vm.user_lang.phone_inst,
      "data-toggle": "tooltip",
      "data-placement": "right"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row-spacing",
    attrs: {
      "id": "phoneModal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.codeSent),
      expression: "codeSent"
    }],
    staticClass: "field-spacing",
    staticStyle: {
      "color": "#a7a7a7"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.user_lang.enter_code_rule) + "\n                      ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.codeSent),
      expression: "codeSent"
    }],
    staticClass: "m-form verify-code-form clearfix leave-open-on-success",
    attrs: {
      "id": "smsPhoneCodeForm.edit.form"
    }
  }, [_c('input', {
    staticClass: "hide",
    attrs: {
      "type": "hidden",
      "name": "_xsrfToken",
      "value": "bd39219af46c391c0ea3df7053f999588ed2ca5a8553eaf83a32d4d3f063915f"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "smsFactor",
      "value": "true"
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "hide",
    attrs: {
      "name": "activateFactor",
      "value": "false",
      "type": "hidden"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "margin-btm-0",
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "id": "smsPhoneCodeForm.code.label",
      "for": "verifyCode",
      "path": "token",
      "csserrorclass": "error"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.enter_code) + "\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "padding-right": "10px"
    }
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "text-align": "left",
      "padding-right": "5px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.verifycode),
      expression: "verifycode"
    }],
    staticClass: "verify-input",
    attrs: {
      "id": "verifyCode",
      "name": "code",
      "type": "text",
      "value": "",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.verifycode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.verifycode = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "padding-top": "10px"
    }
  }, [_c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-4 col-xs-12",
    staticStyle: {
      "text-align": "left",
      "padding-right": "5px"
    }
  }, [_c('input', {
    staticClass: "ajax-form-submit verify-sms save button",
    class: {
      disabled: _vm.verifyClicked
    },
    attrs: {
      "value": _vm.user_lang.verify,
      "name": "m-save",
      "type": "button",
      "id": "smsPhoneCodeForm.button.submit"
    },
    on: {
      "click": function($event) {
        _vm.verifySMS()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-4 col-xs-12",
    staticStyle: {
      "text-align": "left",
      "padding-right": "5px"
    }
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.codeSent),
      expression: "codeSent"
    }],
    staticClass: "phoneVerification",
    on: {
      "click": function($event) {
        _vm.goBack()
      }
    }
  }, [_vm._v("\n                              " + _vm._s(_vm.user_lang.back) + "\n                            ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-4 col-xs-12",
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.codeSent),
      expression: "codeSent"
    }],
    staticClass: "phoneVerification",
    on: {
      "click": function($event) {
        _vm.cancelVerification()
      }
    }
  }, [_vm._v("\n                              " + _vm._s(_vm.user_lang.cancel) + "\n                            ")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.iserror),
      expression: "iserror"
    }],
    staticStyle: {
      "padding-top": "5px"
    },
    attrs: {
      "id": "smsPhoneCodeForm.edit.errors"
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "5px",
      "background": "rgb(255, 192, 203)",
      "padding-left": "15px",
      "margin-top": "5px"
    }
  }, [_vm._v(_vm._s(_vm.verifyCodeError) + "\n                          ")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.codeSent),
      expression: "!codeSent"
    }],
    staticClass: "edit-form clearfix"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "padding-0 margin-0 autowidth float-n",
    attrs: {
      "id": "smsPhoneWidget"
    }
  }), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "field-spacing"
  }, [_c('div', [_c('span', {
    attrs: {
      "for": "countryCode"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.country))]), _vm._v(" "), _c('span', {
    staticClass: "fa fa-info-circle",
    staticStyle: {
      "padding-left": "5px"
    },
    attrs: {
      "title": _vm.user_lang.country_inst,
      "data-original-title": _vm.user_lang.country_inst,
      "data-toggle": "tooltip",
      "data-placement": "right"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }, [(_vm.paramLang !== 'es_ES') ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.countryCode),
      expression: "countryCode"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": "countryCode",
      "name": "countryCode",
      "autocomplete": "off"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.countryCode = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.dropdownList.common), function(obj) {
    return _c('option', {
      key: obj.key,
      domProps: {
        "value": obj.key
      }
    }, [_vm._v("\n                                  " + _vm._s(_vm.user_lang[("" + (obj.value))]) + "\n                                ")])
  })) : _vm._e(), _vm._v(" "), (_vm.paramLang === 'es_ES') ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.countryCode),
      expression: "countryCode"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": "countryCode",
      "name": "countryCode",
      "autocomplete": "off"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.countryCode = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.dropdownList.es), function(obj) {
    return _c('option', {
      key: obj.key,
      domProps: {
        "value": obj.key
      }
    }, [_vm._v("\n                                  " + _vm._s(_vm.user_lang[("" + (obj.value))]) + "\n                                ")])
  })) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "field-spacing"
  }, [_c('div', {
    class: _vm.browserLang === 'uk' ? 'margintop' : ''
  }, [_c('span', {
    attrs: {
      "for": "phN"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.nopMobile))]), _c('span', {
    staticClass: "fa fa-info-circle",
    staticStyle: {
      "padding-left": "5px"
    },
    attrs: {
      "title": _vm.user_lang.nop_inst,
      "data-original-title": _vm.user_lang.nop_inst,
      "data-toggle": "tooltip",
      "data-placement": "right"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phN),
      expression: "phN"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "text",
      "id": "pn",
      "name": "phN"
    },
    domProps: {
      "value": (_vm.phN)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phN = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "field-spacing"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.codeSent),
      expression: "!codeSent"
    }],
    staticClass: "send-code",
    class: {
      disabled: !_vm.phN.trim().length
    },
    on: {
      "click": function($event) {
        _vm.sendCode()
      }
    }
  }, [_vm._v("\n                              " + _vm._s(_vm.user_lang.send_code) + "\n                            ")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isPhoneNoNotVerified),
      expression: "isPhoneNoNotVerified"
    }],
    staticStyle: {
      "padding": "5px 15px",
      "background": "#f3db79",
      "border": "1px solid #ffcc12",
      "margin-top": "5px",
      "width": "100%"
    }
  }, [_c('i', {
    staticClass: "fa fa-warning",
    staticStyle: {
      "padding": "5px 5px 5px 0px"
    }
  }), _vm._v(_vm._s(_vm.user_lang.verifyPhoneWarning) + "\n                          ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.error30SecOTP == true),
      expression: "error30SecOTP == true"
    }],
    staticClass: "phone-error"
  }, [_vm._v(_vm._s(_vm.user_lang.OTPEnableAfter30Sec) + "\n                          ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.phoneNumberNotValid == true),
      expression: "phoneNumberNotValid == true"
    }],
    staticClass: "phone-error"
  }, [_vm._v(_vm._s(_vm.user_lang.phonenumberinvalid) + "\n                          ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.phoneNoAlreadySet == true),
      expression: "phoneNoAlreadySet == true"
    }],
    staticClass: "phone-error"
  }, [_vm._v(_vm._s(_vm.user_lang.phoneNoAlreadySet) + "\n                          ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.genericErrorMsg),
      expression: "genericErrorMsg"
    }],
    staticClass: "phone-error"
  }, [_vm._v("\n                            " + _vm._s(_vm.user_lang.msgForUnhandledResponse) + "\n                          ")])]), _vm._v(" "), _vm._m(3)])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.alreadyRegistered),
      expression: "alreadyRegistered"
    }],
    staticStyle: {
      "margin-left": "15px",
      "padding": "0px 15px"
    }
  }, [_c('div', {
    staticClass: "success-text",
    staticStyle: {
      "color": "green",
      "font-weight": "bold"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.user_lang.phonealreadyactive) + "\n                ")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.issuccess),
      expression: "issuccess"
    }],
    staticStyle: {
      "margin-left": "15px",
      "padding": "0px 15px"
    }
  }, [_c('span', {
    staticClass: "success-text",
    staticStyle: {
      "color": "green",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.verify_success))])])]), _vm._v(" "), _c('div', {
    staticClass: "setup-section col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [(_vm.brand.toLowerCase().indexOf('cargill') == -1) ? _c('div', _vm._l((_vm.termsArray), function(i, index) {
    return _c('div', {
      key: index,
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.brandtermagree[index]),
        expression: "brandtermagree[index]"
      }],
      staticClass: "input-terms",
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(_vm.brandtermagree[index]) ? _vm._i(_vm.brandtermagree[index], null) > -1 : (_vm.brandtermagree[index])
      },
      on: {
        "__c": function($event) {
          var $$a = _vm.brandtermagree[index],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.brandtermagree[index] = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.brandtermagree[index] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.$set(_vm.brandtermagree, index, $$c)
          }
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "brand-terms"
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(i)
      }
    })])])])
  })) : _vm._e(), _vm._v(" "), (_vm.brand.toLowerCase().indexOf('cargill') > -1) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.agreeone),
      expression: "agreeone"
    }],
    staticClass: "input-terms",
    attrs: {
      "id": "agree1",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.agreeone) ? _vm._i(_vm.agreeone, null) > -1 : (_vm.agreeone)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.agreeone,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.agreeone = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.agreeone = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.agreeone = $$c
        }
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "brand-terms"
  }, [_c('span', [_vm._v(_vm._s(_vm.user_lang.iread1))]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.tclink,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.iread2))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.user_lang.iread3))])])])]) : _vm._e(), _vm._v(" "), (_vm.brand.toLowerCase().indexOf('cargill') > -1) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.agreetwo),
      expression: "agreetwo"
    }],
    staticClass: "input-terms",
    attrs: {
      "id": "agree2",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.agreetwo) ? _vm._i(_vm.agreetwo, null) > -1 : (_vm.agreetwo)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.agreetwo,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.agreetwo = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.agreetwo = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.agreetwo = $$c
        }
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "brand-terms"
  }, [_c('span', [_vm._v(_vm._s(_vm.user_lang.iagree1))]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.pplink,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.iagree2))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.user_lang.iagree3))])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errorCode != ''),
      expression: "errorCode != ''"
    }],
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "display": "flex",
      "margin-left": "auto",
      "margin-right": "auto",
      "text-align": "left",
      "padding-top": "0px",
      "background": "#ffc0cb",
      "margin-top": "5px"
    }
  }, [_c('div', {
    staticStyle: {
      "color": "#333",
      "font-size": "13px",
      "padding": "5px"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.user_lang[_vm.errorCode]) + "\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6 col-md-6 offset-md-6 offset-lg-6 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticStyle: {
      "display": "inline-block"
    },
    on: {
      "click": function($event) {
        _vm.isCheckboxDisabled()
      }
    }
  }, [_c('button', {
    staticClass: "btn-primary create-acc",
    class: {
      disabled:
        (_vm.brand.toLowerCase().indexOf('cargill') > -1 && (!_vm.agreeone || !_vm.agreetwo)) ||
        (_vm.brand.toLowerCase().indexOf('cargill') == -1 && !(_vm.brandtermagree.filter(function (i) { return i == true; }).length === _vm.termsArray.length))
    },
    attrs: {
      "value": _vm.user_lang.create_acc
    },
    on: {
      "click": function($event) {
        _vm.setUserAccount()
      }
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.user_lang.create_acc) + "\n                    ")])])])])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.accountsetup),
      expression: "accountsetup"
    }],
    attrs: {
      "id": "congrats"
    }
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "background": "#fff"
    }
  }, [_c('div', {
    staticStyle: {
      "max-width": "800px",
      "margin": "auto"
    }
  }, [_c('div', {
    staticClass: "setup-section col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticStyle: {
      "font-size": "22px",
      "width": "80%",
      "display": "inline-block",
      "margin-bottom": "10px"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.internalUser ? _vm.user_lang.alreadyactive : _vm.user_lang.congrats) + "\n                "), _c('div', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.internalUser ? _vm.user_lang.alreadyactivesetup : _vm.user_lang.accountsetup) + "\n                ")])]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.regApps.length !== 0),
      expression: "regApps.length !== 0"
    }],
    staticStyle: {
      "font-size": "16px",
      "width": "80%",
      "display": "inline-block",
      "margin-bottom": "10px"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.user_lang.gotoapp) + "\n              ")]), _vm._v(" "), _vm._l((_vm.regApps), function(i, index) {
    return _c('div', {
      key: index,
      staticClass: "col-lg-4 col-md-4 col-sm-6 col-xs-6 regapps",
      attrs: {
        "title": i.label
      },
      on: {
        "click": function($event) {
          _vm.goToApp(i.name.toLowerCase() === 'bookmark' ? i.settings.app.url : i._links.appLinks[0].href)
        }
      }
    }, [_c('div', {
      staticClass: "icon-wrap"
    }, [_c('img', {
      staticStyle: {
        "max-width": "90px"
      },
      attrs: {
        "src": i._links.logo[0].href
      }
    })]), _vm._v(" "), _c('div', [_vm._v(_vm._s(i.label))])])
  })], 2)])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "okta-sign-in-header auth-header"
  }, [_c('img', {
    staticClass: "auth-org-logo",
    attrs: {
      "src": "static/1200px-Cargill_logo.svg.png",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "block",
      "text-align": "center"
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle",
    staticStyle: {
      "font-size": "50px",
      "color": "var(--theme-primary)"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "padding-0 margin-0 autowidth float-n normal"
  }, [_c('div', {
    staticClass: "infobox infobox-error margin-btm",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "smsPhoneSetupForm.edit.errors"
    }
  }, [_c('span', {
    staticClass: "icon error-16"
  }), _vm._v(" "), _c('p', [_vm._v("Please review the form to correct the following errors")]), _vm._v(" "), _c('ul', {
    staticClass: "bullets"
  }, [_c('li', [_c('span', {
    attrs: {
      "id": "smsPhoneSetupForm.passcode.error"
    }
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "padding-0 margin-0 autowidth float-n normal"
  }, [_c('div', {
    staticClass: "infobox infobox-success infobox-md clear margin-top",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "smsPhoneSetupForm-edit-success"
    }
  }, [_c('span', {
    staticClass: "icon success-24"
  }), _vm._v(" "), _c('p', {
    staticClass: "success-text"
  }, [_vm._v("Phone number successfully verified!")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "inline-block",
      "width": "20%",
      "float": "right"
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle",
    staticStyle: {
      "font-size": "50px",
      "color": "var(--theme-primary)"
    }
  })])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7cc2de36", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7cc2de36"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/UserRegistration.vue
// module id = 702
// module chunks = 1